import React from 'react';
import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: '#1a237e',
  '&.Mui-checked': {
    color: '#1a237e',
  },
  '&:hover': {
    backgroundColor: 'rgba(26, 35, 126, 0.08)',
  },
}));

export default StyledRadio; 